// Simple event-based toast system — works from context.tsx without circular deps

export type ToastType = 'error' | 'success' | 'info';

export interface ToastEvent {
  message: string;
  type: ToastType;
}

export function showToast(message: string, type: ToastType = 'error') {
  window.dispatchEvent(
    new CustomEvent<ToastEvent>('nudge:toast', {
      detail: { message, type },
    }),
  );
}
